import { withLayout } from '@lib/rn-utils';
import styled, { css } from 'styled-components';

export const ListDataLineChartSC = styled.div`
  width: 100%;
  height: 16px;

  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const TachometerBar = withLayout(styled.div`
  width: 100%;
  height: 16px;
  position: relative;
  display: flex;
  align-items: center;

  .tachometer-bar-track {
    width: 100%;
    height: 3px;
    position: relative;
    border-radius: 10px;
    transition: all 0.2s;

    .tachometer-bar-pinter {
      position: absolute;
      width: 8px;
      height: 16px;
      transition: all 0.2s;
      top: -6.5px;
      border-radius: 6px;

      ${({ theme }) => css`
        background: red;
        border: 2px solid ${theme.color.surface.baseline};
        box-shadow: ${theme.shadows.low};
      `};
    }
  }
`);
